import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faFlag } from '@fortawesome/free-solid-svg-icons';
import { estimarTiempo } from '../../utils/tarifaCalculator';

const TripSummary = ({
  pickupAddress,
  dropoffAddress,
  distancia,
  passengerCount,
  referencePoints = []
}) => {
  return (
    <Card className="border-0 shadow-sm rounded-16 mb-3">
      <Card.Body className="p-3">
        <h6 className="fw-bold mb-3">Resumen del viaje</h6>
        <div className="d-flex align-items-start gap-2 mb-2">
          <FontAwesomeIcon icon={faMapMarkerAlt} color="#0EABB0" className="mt-1" />
          <div>
            <small className="text-muted d-block" style={{ fontSize: 11 }}>ORIGEN</small>
            <span style={{ fontSize: 14 }}>{pickupAddress || 'Ubicación actual'}</span>
          </div>
        </div>
        <div className="d-flex align-items-start gap-2 mb-2">
          <FontAwesomeIcon icon={faMapMarkerAlt} color="#121212" className="mt-1" />
          <div>
            <small className="text-muted d-block" style={{ fontSize: 11 }}>DESTINO</small>
            <span style={{ fontSize: 14 }}>{dropoffAddress || 'Destino'}</span>
          </div>
        </div>
        
        <div className="d-flex gap-3 mt-3 text-center">
          <div className="flex-fill p-2 rounded-12" style={{ background: '#F5F5F5' }}>
            <small className="text-muted d-block">Distancia</small>
            <strong>{distancia} km</strong>
          </div>
          <div className="flex-fill p-2 rounded-12" style={{ background: '#F5F5F5' }}>
            <small className="text-muted d-block">Duración</small>
            <strong>~{estimarTiempo(distancia)} min</strong>
          </div>
        </div>
        
        {passengerCount > 1 && (
          <div className="mt-2 text-center">
            <small className="text-muted d-block">Pasajeros</small>
            <strong>{passengerCount}</strong>
          </div>
        )}
        
        {referencePoints.length > 0 && (
          <div className="mt-3 p-2 rounded-12" style={{ background: '#F8FAFC' }}>
            <small className="text-muted d-block mb-1">
              <FontAwesomeIcon icon={faFlag} className="me-1" style={{ color: '#0EABB0' }} />
              Puntos de referencia ({referencePoints.length})
            </small>
            <div style={{ fontSize: 12 }} className="text-dark">
              {referencePoints.map((rp, i) => (
                <span key={i} className="d-block">• {rp.label || `Punto ${i + 1}`}</span>
              ))}
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default TripSummary;
